import { Col, Row } from "react-bootstrap";
import { IEpaCorrespondenceDetails } from "../../../api/IEpaCorrespondence";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface EpaCorrespondenceDetailsProps {
  epaCorrespondence: IEpaCorrespondenceDetails;
}

const EpaCorrespondenceDetails = ({
  epaCorrespondence,
}: EpaCorrespondenceDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Submitted by the EPA"}
            value={epaCorrespondence.datesubmitted}
          />
          <EpaField label={"Subject"} value={epaCorrespondence.subject} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Licensee Response Due Date"}
            value={epaCorrespondence.duedate}
          />
          <EpaField
            label={"Correspondence Type"}
            value={epaCorrespondence.correspondencetype}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Correspondence from EPA"}
            value={epaCorrespondence.licensingnotification}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard
      title={"EPA Initiated Correspondence Details"}
      content={bodyElements}
    />
  );
};

export default EpaCorrespondenceDetails;
